define('community-threads-add',['controller', 'community-editor'], function(controller, editor) {
	controller.on('community/threads/add', function() {
		editor.initMCE("#thread-text-input");
	});
});

